import { PublicClientApplication, BrowserCacheLocation } from "@azure/msal-browser";

const msal = new PublicClientApplication({
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
        redirectUri: "/auth",
        postLogoutRedirectUri: "/",
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
        allowRedirectInIframe: true
    }
});

export default msal;